import type { ICustomSelectValue } from '@sravni/cosago-react-library/lib/types';

import type { TCustomerUpdateAddress } from 'shared/types/TCustomerService';
import type { TFullData } from 'shared/types/TUserAddressFields';

export const formAddressToCustomerAdapter = (
  address: Nullable<ICustomSelectValue<TFullData>> | undefined,
  optionalData?: {
    locationRoute?: string | null;
    flat?: string | null;
  },
): TCustomerUpdateAddress | null => {
  if (!address?.data) {
    return null;
  }

  const { value, data } = address;
  const {
    fias_id,
    fias_level,
    region_with_type,
    region_fias_id,
    city_with_type,
    city_fias_id,
    settlement_with_type,
    settlement_fias_id,
    street_with_type,
    street_fias_id,
    house,
  } = data;

  const optionalLocationRoute = optionalData?.locationRoute || null;
  const optionalFlat = optionalData?.flat || null;

  return {
    dadata: String(value),
    fias_level,
    fias_id: String(fias_id),
    region_with_type: region_with_type ? String(region_with_type) : null,
    region_fias_id: region_fias_id ? String(region_fias_id) : null,
    city_with_type: city_with_type ? String(city_with_type) : null,
    city_fias_id,
    settlement_with_type: settlement_with_type ? String(settlement_with_type) : null,
    settlement_fias_id,
    street_with_type: street_with_type ? String(street_with_type) : null,
    street_fias_id,
    house: house ? String(house) : null,
    location_route: optionalLocationRoute,
    full_string: optionalFlat ? [String(value), optionalFlat].join(', кв ') : String(value),
  };
};
